import { UnstyledButton } from "Components/Shared/Buttons/UnstyledButton";
import { LogoutRoundedIcon } from "Components/Shared/Icons";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  onClick: () => void;
  isDisabled?: boolean;
};

export const LeaveRegistrationButton = ({ onClick, isDisabled }: Props) => {
  const { t } = useResource();

  return (
    <UnstyledButton
      onClick={onClick}
      disabled={isDisabled}
      sx={{
        color: ({ palette }) => palette.info.main,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <LogoutRoundedIcon height={15} width={15} />
      {t(Resources.Components.Onboarding.LogoutButtonLabel)}
    </UnstyledButton>
  );
};
